import React, { useCallback } from 'react';
import { useField } from 'formik';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { MultiSelect } from '@/components/ui/multi-select';

import { WEBHOOK_EVENTS } from '@/schemas/agent.schema';

const WEBHOOK_EVENT_OPTIONS = [...WEBHOOK_EVENTS];

export const EventsCard = React.memo(() => {
  const [field, , helpers] = useField<string[]>('webhook_config.events');

  const onValueChange = useCallback(
    (updated: string[]) => helpers.setValue(updated),
    [helpers.setValue]
  );

  return (
    <Card className="bg-muted rounded-2xl gap-0 p-1 border-0 shadow-none">
      <CardHeader className="px-5 py-3">
        <CardTitle className="text-sm font-semibold">Events</CardTitle>
        <p className="text-sm text-muted-foreground">
          Select which events will trigger the webhook.
        </p>
      </CardHeader>
      <CardContent className="bg-card rounded-xl shadow-sm p-5">
        <MultiSelect
          options={WEBHOOK_EVENT_OPTIONS}
          value={field.value ?? []}
          onValueChange={onValueChange}
          placeholder="Select events..."
        />
      </CardContent>
    </Card>
  );
});
